// Sales-order BODY fields a configuration wants written back onto the order.
//
// The mapping from "an answer a configurator computed" to "a field on the order" is
// declared by that configurator (src/products/), so this module is the shared
// mechanism and holds no product knowledge. Flame Cells is the only product with any
// today: its Shipping Instructions operation (seq 014) computes the starbar note into
// the hidden SHIP_STAR_BARS_2 field, which nothing consumed -- no ITCR maps it
// anywhere, so the text was computed and thrown away.
import type { AnswerState } from "../types";
import type { OrderFieldWrites } from "./salesOrderBridge";
import { getProfile } from "../products";

/** Order body fields this configuration wants set. {} for a product with none. */
export function buildOrderFields(product: string, answers: AnswerState): OrderFieldWrites {
  const rows = getProfile(product).orderFields;
  if (rows.length === 0) return {};
  const out: OrderFieldWrites = {};
  for (const [answerKey, fieldId] of rows) {
    // Trimmed because the source operation builds the string as
    // `getOrderField(...) + '\n' + <note>`, and getOrderField is a stub returning "",
    // so the value arrives with a LEADING NEWLINE. Trimming here rather than editing
    // their operation script keeps that script untouched.
    const raw = String(answers[answerKey] ?? "").trim();
    if (raw !== "") out[fieldId] = raw;
  }
  return out;
}
